export default __webpack_public_path__ + "d1f9ea652e63f0662b92311697a464ce.png";